<template>
    <b-row>
        <b-col md="4" cols="12">
            <b-card class="profile-header">
                <div class="info-card w-100 px-2 py-1">
                    <h6
                    style="width: fit-content; padding: 4px 6px"
                    class="bg-info rounded mb-1 text-white font-weight-bold"
                    >
                    الشعار 
                    </h6>
                    <div class="profile-img d-flex justify-content-center ">
                    <b-img
                        style="height: 50%; width: 50%"
                        :src="url"
                        rounded
                        fluid
                        alt="profile photo"
                    />

                    </div>
                    <hr />
                </div>

            </b-card>
        </b-col>
    </b-row>
  </template>
  
  <script>
  import { BRow , BCard , BImg , BCol } from "bootstrap-vue";
  export default {
    components: {
        BRow , BCard, BImg , BCol
    },
    props: {
      url: String | Number,
    },
  };
  </script>